module.exports = __webpack_public_path__ + "static/metalProduct2-2bd5c62cd0f20fb367e941d5645307a2.jpg";